
















import {Component, Mixins} from 'vue-mixin-decorator';

import SystemInfoHardware from '@/components/System/SystemInfoHardware.vue';
import SystemInfoOs from '@/components/System/SystemInfoOs.vue';
import SystemInfoGeneral from '@/components/System/SystemInfoGeneral.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {SystemInfoGeneral, SystemInfoOs, SystemInfoHardware},
})
export default class SystemInfoPage extends Mixins<BaseComponent>(BaseComponent) {
  private systemInfoPanels: any = [
    {
      id: 'os',
      label: 'Operating system',
      component: 'system-info-os',
    },
    {
      id: 'hardware',
      label: 'Hardware',
      component: 'system-info-hardware',
    },
    {
      id: 'system',
      label: 'System',
      component: 'system-info-general',
    },
  ];
}
